import { createAction } from "redux-actions";

export const USER_SELECTS_PRIMARY_FILTER_TYPE = "USER_SELECTS_PRIMARY_FILTER_TYPE";
export const userSelectsPrimaryFilterType = createAction(USER_SELECTS_PRIMARY_FILTER_TYPE);

export const USER_SELECTS_PRIMARY_OPTIONS = "USER_SELECTS_PRIMARY_OPTIONS";
export const userSelectsPrimaryOptions = createAction(USER_SELECTS_PRIMARY_OPTIONS);
